import axios from "axios";
import { BASE_URL_CONTENT } from "../store";
import modelContentMenu, { modelFlatContentMenu } from "../models/contentMenu";

export const contentMenu = locale => async () => {
  const response = await axios.get(
    `${BASE_URL_CONTENT}/index.php/${locale.substring(0, 2)}`
  );
  if (response.statusText === "OK") {
    let data = response.data;

    return {
      menu: modelContentMenu(data),
      links: modelFlatContentMenu(data)
    };
  } else {
    throw response.status;
  }
};



// WEBPACK FOOTER //
// ./src/redux/api/contentMenu.js